module.exports = __webpack_public_path__ + "img/tab@2x.14d8818f.png";